import Crud from './crud'
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
var crud = new Crud('payment-request', 'yêu cầu giao hàng');

const state = {
    ...crud.state,
    orders: {},
    packages: {},
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getOrderList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('payment-request/order-list', data => {
            commit('setOrderList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getPackageList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('payment-request/package-list', data => {
            commit('setPackageList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
};
const mutations = {
    ...crud.mutations,
    setOrderList(state, data) {
        state.orders = data;
    },
    setPackageList(state, data) {
        state.packages = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};